/* eslint-disable */
import React, { useEffect, useState } from "react";
import Statistics from "..";
import {
  getSubscriptionsStats,
  getStatisticsSuccess,
} from "../../../actions";
import "./styles.scss";
import { connect } from "react-redux";
import Popup from "reactjs-popup";
import moment from "moment";
import Inputs from "../../Inputs";
import PeriodSelector from "../../PeriodSelector";
import { history } from "../../../config/stores";

const Subscriptions = ({
  getSubscriptionsStats,
  getStatisticsSuccess,
  subscriptions,
}) => {
  const [selPeriod, setSelPeriod] = useState({
    startDate: null,
    endDate: moment().toString(),
  });
  const [historicLoading, setHistoricLoading] = useState(false);
  const [selected, setSelected] = useState("users");
  const [selectedPeriodLabel, setSelectedPeriodLabel] = useState("All time");
  const [selectedPeriodType, setSelectedPeriodType] = useState("all");

  useEffect(() => {
    getStatisticsSuccess({ type: "subscriptions", loading: true });
    getSubscriptionsStats();
  }, []);

  useEffect(() => {
    // Only trigger API call when startDate changes from user interaction
    if (selPeriod.startDate !== null && selPeriod.startDate !== "") {
      setHistoricLoading(true);
      getSubscriptionsStats({
        startDate: selPeriod.startDate,
        endDate: selPeriod.endDate,
        onSuccess: () => setHistoricLoading(false),
        onError: () => setHistoricLoading(false),
      });
    }
  }, [selPeriod.startDate]);

  const handlePeriodApply = (periodData) => {
    setSelPeriod({
      startDate: periodData.startDate,
      endDate: periodData.endDate,
    });
    setSelectedPeriodLabel(periodData.label);
    setSelectedPeriodType(periodData.type);
    
    // Handle API call logic
    if (periodData.type === "all") {
      setHistoricLoading(true);
      getSubscriptionsStats({
        startDate: "",
        endDate: "",
        onSuccess: () => setHistoricLoading(false),
        onError: () => setHistoricLoading(false),
      });
    } else if (periodData.startDate) {
      setHistoricLoading(true);
      getSubscriptionsStats({
        startDate: periodData.startDate,
        endDate: periodData.endDate,
        onSuccess: () => setHistoricLoading(false),
        onError: () => setHistoricLoading(false),
      });
    }
  };

  return (
    <div
      className="statistics-sessions-container col"
      style={{ overflow: "auto" }}
    >
      <div
        style={{
          margin: "0px",
          marginTop: "10px",
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            paddingBottom: "0px",
            color: "#333",
            fontSize: "1.5rem",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          SUBSCRIPTIONS
        </h2>
      </div>

      {/* Selector buttons */}
      <div style={{ marginBottom: "20px" }}>
        <div className="selector-container">
          <div
            className={`select ${selected === "users" && "selected"}`}
            onClick={() => setSelected("users")}
          >
            USERS
          </div>
          <div
            className={`select ${selected === "communities" && "selected"}`}
            onClick={() => setSelected("communities")}
          >
            COMMUNITIES
          </div>
        </div>
      </div>

      <div
        className="statistics-sessions-content"
        style={{ overflow: "unset" }}
      >
        {/* Current Subscriptions Pie Chart */}
        <div
          className="statistics-sessions-section col"
          style={{ marginBottom: "20px" }}
        >
          <h4>CURRENT {selected.toUpperCase()} STATISTICS</h4>
          <div style={{ minHeight: "183px" }}>
            {subscriptions.loading ? (
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                height: "183px" 
              }}>
                <Statistics.LoaderInline />
              </div>
            ) : (
              <Statistics.SubscriptionPie
                colors={selected === "users" ? ["#00D297", "#9325FF", "#002C78"] : ["#00D297", "#002C78"]}
                context={selected}
                data={
                  selected === "users" ? [
                    {
                      label: subscriptions?.users?.free || 0,
                      value: "FREE",
                    },
                    {
                      label: subscriptions?.users?.monthly || 0,
                      value: "MONTHLY",
                    },
                    {
                      label: subscriptions?.users?.annual || 0,
                      value: "ANNUAL",
                    },
                  ] : [
                    {
                      label: subscriptions?.communities?.free || 0,
                      value: "FREE",
                    },
                    {
                      label: subscriptions?.communities?.subscribed || 0,
                      value: "SUBSCRIBED",
                    },
                  ]
                }
              />
            )}
          </div>
        </div>

        {/* Historic Subscriptions Pie Chart with Period Control */}
        <div
          className="statistics-sessions-section col"
          style={{ marginBottom: "20px" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            <h4 style={{ margin: "0" }}>HISTORIC {selected.toUpperCase()} DATA</h4>
            <div style={{ display: "flex", alignItems: "center" }}>
              <p
                style={{
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  margin: "0px 10px",
                }}
              >
                {selectedPeriodLabel}
              </p>
              <Popup
                className="popup-header-options-container"
                trigger={<div className={`settings-icon`} />}
                position="bottom right"
                closeOnDocumentClick
              >
                {(close) => (
                  <PeriodSelector
                    selectedPeriod={selectedPeriodType}
                    onApply={(periodData) => {
                      handlePeriodApply(periodData);
                      close();
                    }}
                  />
                )}
              </Popup>
            </div>
          </div>
          <div style={{ position: "relative", minHeight: "200px" }}>
            {historicLoading ? (
              <div style={{ 
                position: "absolute", 
                top: "50%", 
                left: "50%", 
                transform: "translate(-50%, -50%)",
                zIndex: 2
              }}>
                <Statistics.LoaderInline />
              </div>
            ) : null}
            <div style={{ opacity: historicLoading ? 0.3 : 1 }}>
              <Statistics.SubscriptionPie
                colors={selected === "users" ? ["#00D297", "#9325FF", "#002C78"] : ["#00D297", "#002C78"]}
                context={selected}
                data={
                  selected === "users" ? [
                    {
                      label: subscriptions?.users?.free || 0,
                      value: "FREE",
                    },
                    {
                      label: subscriptions?.users?.monthly || 0,
                      value: "MONTHLY",
                    },
                    {
                      label: subscriptions?.users?.annual || 0,
                      value: "ANNUAL",
                    },
                  ] : [
                    {
                      label: subscriptions?.communities?.free || 0,
                      value: "FREE",
                    },
                    {
                      label: subscriptions?.communities?.subscribed || 0,
                      value: "SUBSCRIBED",
                    },
                  ]
                }
              />
            </div>
            {/* Paid with Card Info - Only show for Communities */}
            {selected === "communities" && (
              <div
                style={{
                  marginTop: "15px",
                  padding: "10px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                  border: "1px solid #dee2e6",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div 
                      style={{ 
                        width: "3px", 
                        height: "20px", 
                        backgroundColor: "#6c757d", 
                        marginRight: "10px",
                        borderRadius: "2px"
                      }}
                    />
                    <span style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#333" }}>
                      TO DO PAID WITH CARD
                    </span>
                  </div>
                  <div
                    className="info-icon"
                    onClick={() => history.push("/dashboard/subscriptions")}
                  />
                </div>
              </div>
            )}

            {/* Paid via Bank Transfer Info - Only show for Communities */}
            {selected === "communities" && (
              <div
                style={{
                  marginTop: "15px",
                  padding: "10px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                  border: "1px solid #dee2e6",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div 
                      style={{ 
                        width: "3px", 
                        height: "20px", 
                        backgroundColor: "#6c757d", 
                        marginRight: "10px",
                        borderRadius: "2px"
                      }}
                    />
                    <span style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#333" }}>
                      TO DO PAID VIA BANK TRANSFER
                    </span>
                  </div>
                  <div
                    className="info-icon"
                    onClick={() => history.push("/dashboard/subscriptions")}
                  />
                </div>
              </div>
            )}

            {/* Total Count Info */}
            <div
              style={{
                marginTop: "15px",
                padding: "10px",
                backgroundColor: "#f8f9fa",
                borderRadius: "4px",
                border: "1px solid #dee2e6",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div 
                    style={{ 
                      width: "3px", 
                      height: "20px", 
                      backgroundColor: "#6c757d", 
                      marginRight: "10px",
                      borderRadius: "2px"
                    }}
                  />
                  <span style={{ fontSize: "1.1rem", fontWeight: "bold", color: "#333" }}>
                    {selected === "users" 
                      ? `TO DO`
                      : `TO DO`
                    }
                  </span>
                </div>
                <div
                  className="info-icon"
                  onClick={() => history.push("/dashboard/subscriptions")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  subscriptions: state.dashboard.subscriptions,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscriptionsStats: (payload) => dispatch(getSubscriptionsStats(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);
